import { DialogLauncher } from '@formstack/phoenix/components/DialogLauncher';

import { ConnectorIds } from '@/common/constants';

import { UpsellDialog } from './UpsellDialog';

export const launchUpsellDialog = (connectorId: ConnectorIds) => {
  DialogLauncher.open({
    component: UpsellDialog,
    data: { connectorId },
  });
};
